export default {
  GPS: 'GPS',
  featureComingSoon: 'ฟีเจอร์นี้จะเปิดตัวเร็วๆนี้',
  assign: 'มอบหมาย',
};